import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/extra-payment-calculator',
  component: () => import('../../routes/ExtraPaymentCalculator.svelte'),
  card: {
    id: 'extra-payment-calculator',
    title: 'Loan Payoff Extra Payment',
    description: 'Calculate how extra monthly payments accelerate loan payoff, reduce total interest, and shorten your loan term.',
    icon: 'speed',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/extra-payment-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Loan Payoff Extra Payment Calculator – Accelerate Loan Payoff',
    description: 'Free extra payment calculator shows how additional monthly payments reduce total interest and shorten loan term. See exactly when you\'ll be debt-free.',
  },
};

export default meta;